import script from "./VideoPost.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoPost.vue?vue&type=script&setup=true&lang=js"

import "./VideoPost.vue?vue&type=style&index=0&id=39e449c7&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39e449c7"]])

export default __exports__